/* istanbul ignore file */
import { fetch } from 'src/services/apollo-fetch';
import { Query } from '../_api';

export default {
  async fetchContactMessagesCount() {
    const response = await fetch.query({
      query: Query.contactMessagesCount,
    });
    return response.data.contactMessagesCount;
  },
  async fetchUsersCount() {
    const response = await fetch.query({
      query: Query.usersCount,
    });
    return response.data.usersCount;
  },
  async fetchBookingRequestsCount() {
    const response = await fetch.query({
      query: Query.bookingRequestsCount,
    });
    return response.data.bookingRequestsCount;
  },
};
